module.exports = __webpack_public_path__ + "static/media/qr-check.d9b6a362.svg";